import { useContext } from "react";
import useUserState from "../../hooks/useUserState";
import { SubscriptionData } from "../../lib/mappers/subscriptionData";
import StripeWrapper from "../../StripeWrapper";
import FreeTrial from "./FreeTrial";
import { PaymentInfo } from "../../lib/types";
import PaymentInfoContext from "../../context/PaymentInfoContext";

const FreeTrialStripeWrapper = ({
  freeTrialActive,
}: {
  freeTrialActive: boolean;
}) => {
  const { subscriptionInfo } = useUserState();
  const paymentInfo = useContext<PaymentInfo>(PaymentInfoContext);

  if (subscriptionInfo === null) {
    return null;
  }

  const subscriptionData = new SubscriptionData(subscriptionInfo, paymentInfo);

  if (subscriptionData.missingPaymentInfo()) {
    return null;
  }

  return (
    <StripeWrapper clientSecret={subscriptionData.getClientSecret()}>
      <FreeTrial
        freeTrialActive={freeTrialActive}
        subscriptionData={subscriptionData}
      />
    </StripeWrapper>
  );
};

export default FreeTrialStripeWrapper;
